import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchUser } from '../../services/UsersService';
import { User, PatchUserRequest } from '../../types/Users';

type Result = UseMutationResult<User, Error, PatchUserRequest>;

function usePatchUser(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchUser, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['users'] });
      queryClient.invalidateQueries({ queryKey: ['users-lazy'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchUser;
